module.exports = __webpack_public_path__ + "img/imac.f926df39.png";